export const SET_ACTIVE_NAV = 'SET_ACTIVE_NAV';

export const setActiveNav = (nav) => ({
    type: SET_ACTIVE_NAV,
    payload: nav,
});